import './Method.css';
import content from '../data/content.json';

const Method: React.FC = () => {
  return (
    <section className="method" id="metodo">
      <div className="container">
        <h2>{content.method.title}</h2>
        <p className="method-subtitle">{content.method.subtitle}</p>

        <div className="method-steps">
          {content.method.steps.map((step, index) => (
            <div key={index} className="method-step">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Method;
